import { formatToDate } from "../../master/FormatToDateTime";

export const STUDENT_COLUMNS = [
  {
    key: "name",
    label: "Student Name",
    value: (item) => item?.name ?? "",
  },
  {
    key: "registration_no",
    label: "Registration No",
    value: (item) => item?.registration_no ?? "",
  },
  {
    key: "roll_number",
    label: "Roll No",
    value: (item) => item?.course_and_fee_info?.roll_number ?? "",
  },
  {
    key: "father_name",
    label: "Father Name",
    value: (item) => item?.father_name ?? "",
  },
  {
    key: "mother_name",
    label: "Mother Name",
    value: (item) => item?.mother_name ?? "",
  },
  {
    key: "father_occupation",
    label: "Father Occupation",
    value: (item) => item?.father_occupation ?? "",
  },
  {
    key: "phone",
    label: "Mobile",
    value: (item) => item?.phone ?? "",
  },
  {
    key: "secondary_mobile",
    label: "Secondary Mobile",
    value: (item) => item?.secondary_mobile ?? "",
  },
  {
    key: "father_mobile",
    label: "Father Mobile",
    value: (item) => item?.father_mobile ?? "",
  },
  {
    key: "father_aadhar",
    label: "Father Aadhar",
    value: (item) => item?.father_aadhar ?? "",
  },
  {
    key: "mother_mobile",
    label: "Mother Mobile",
    value: (item) => item?.mother_mobile ?? "",
  },
  {
    key: "mother_aadhar",
    label: "Mother Aadhar",
    value: (item) => item?.mother_aadhar ?? "",
  },
  {
    key: "course",
    label: "Course",
    value: (item) => item?.course_and_fee_info?.course?.title ?? "",
  },
  {
    key: "batch",
    label: "Batch",
    value: (item) => item?.course_and_fee_info?.batch?.title ?? "",
  },
  {
    key: "email",
    label: "Email",
    value: (item) => item?.email ?? "",
  },
  {
    key: "address",
    label: "Address",
    value: (item) =>
      `${item?.village ?? ""} ${item?.district ?? ""} ${item?.state ?? ""} ${item?.zipcode ?? ""}`,
  },
  {
    key: "aadhar",
    label: "Aadhar",
    value: (item) => item?.aadhar ?? "",
  },
  {
    key: "category",
    label: "Category",
    value: (item) => item?.category ?? "",
  },
  {
    key: "gender",
    label: "Gender",
    value: (item) => item?.gender ?? "",
  },
  {
    key: "caste_name",
    label: "Caste",
    value: (item) => item?.caste_name ?? "",
  },
  {
    key: "religion",
    label: "Religion",
    value: (item) => item?.religion ?? "",
  },
  {
    key: "pen_no",
    label: "PEN No",
    value: (item) => item?.pen_no ?? "",
  },
  {
    key: "jan_aadhar",
    label: "JAN Aadhar",
    value: (item) => item?.jan_aadhar ?? "",
  },
  {
    key: "dob",
    label: "DOB",
    value: (item) => formatToDate(item?.dob) ?? "",
  },
  {
    key: "nic_id",
    label: "NIC ID",
    value: (item) => item?.nic_id ?? "",
  },
  {
    key: "apaar_id",
    label: "APAAR ID",
    value: (item) => item?.apaar_id ?? "",
  },
  {
    key: "medium",
    label: "Medium",
    value: (item) => item?.medium ?? "",
  },
  {
    key: "admission_date",
    label: "Admission Date",
    value: (item) => formatToDate(item?.admission_date) ?? "",
  },
  {
    key: "admission_class",
    label: "Admission Class",
    value: (item) => item?.admission_class ?? "",
  },
  {
    key: "manual_remark",
    label: "Manual Remark",
    value: () => "",
  },
];
